import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SKIP_ENCODE_URL } from './http-context-tokens';
import { isServiceUrl } from '../services/platform.service';

@Injectable({ providedIn: 'root' })
export class AppendNoAuthChallengeInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req?.url) {
      // Skip AWS S3 requests
      if (req.url.indexOf('amazonaws') !== -1 && req.url.indexOf(environment.RH_BASE_URL) === -1) {
        return next.handle(req);
      }
    }

    // Determine if this request is to a service node (not cloud-api)
    // Service nodes use JWT Bearer auth, not cookies, so withCredentials should be false
    const isCloudApiRequest = req.url.startsWith(environment.RH_BASE_URL);
    const isServiceNodeRequest = !isCloudApiRequest && isServiceUrl(req.url);

    return next.handle(
      req.clone({
        withCredentials: !isServiceNodeRequest, // Only use credentials for cloud-api requests
        url: req.context.get(SKIP_ENCODE_URL) ? req.url : encodeURI(req.url),
        headers: req.headers.append('No-Auth-Challenge', 'true'),
      })
    );
  }
}
